<div
    *ngIf="
        complementaryReportContent != 'null' &&
        complementaryReportContent != undefined &&
        complementaryReportContent != ''
    "
>
    <div
        *ngIf="complementaryReportContent"
        [innerHtml]="complementaryReportContent | safeHtml"
        [style.--selected-background-color]="backgroundColor"
        [style.color]="textColor"
    ></div>
</div>
